import Model from './Model'

export default class Product extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            category_id: null,
            vehicule_id: null,
            import_id: null,
            brand_id: null,
            manufacturer_id: null,
            manufacturer_slug: null,
            name: null,
            slug: false,
            description: false,
            mf_prefixe: false,
            ean13: null,
            upc: null,
            external_ref: null,
            motocloud_ref: false,
            status: false,
            short_desc: false,
            meta_desc: null,
            meta_title: null,
            technical_desc: null,
            imgs_path: null,
            mf_price: null,
            mf_price_public: null,
            paht: null,
            reapro_type: null,
            out_of_stock_message: null,
            quantity: null,
            has_stock: false,
            is_fournisseur: false,
            is_stock_hybrid: null,
            sale_autorized: false,
            indexed: false,
            activated: false,
            video_path: null,
            popularity: null,
            date_new: null,
            created_at: null,
            updated_at: null,
            deleted_at: null,
            editMode: false,
            datasEditInline: {},
            activity: {},
            width: 0,
            height: 0,
            depth: 0,
            weight: 0,
            ecotax: 0,
            youtube_video: null,
            condition: null,
            ref_kwisatz: null,
            featuresIds: [],
            price_speedway: null,
            date_dispo_pim: null,
            override_manufacturer_coeff: null,
            disallow_coeff_manufacturer: false,
            excluded_carrier_reference: null,
            manufacturer_ref: null,
            avantages: null,
            conseil: null,
        }
    }

    get string_technical_desc() {
        return this.technical_desc ? this.technical_desc.join("\n") : null
    }

    set string_technical_desc(value) {
        if( value ) {
            this.technical_desc = value.split("\n")
        } else {
            this.technical_desc = null
        }
    }

    populateEditMode() {
        this.datasEditInline = {
            id: this.id,
            variation_value_id: this.variation_value_id,
            ean13: this.ean13,
            upc: this.upc,
            external_ref: this.external_ref,
            out_of_stock_message: this.out_of_stock_message,
            quantity: this.quantity,
            has_stock: this.has_stock,
            indexed: this.indexed,
            activated: this.activated,
            sale_autorized: this.sale_autorized,
            popularity: this.popularity,
            variationsCount: this.variationsCount,
            productMaster: false,
            mf_price_public: this.mf_price_public,
            mf_prefixe: this.mf_prefixe,
            manufacturer_slug: this.manufacturer_slug,
            ref_kwisatz: this.ref_kwisatz,
            price_speedway: this.price_speedway,
            date_dispo_pim: this.date_dispo_pim,
            manufacturer_ref: this.manufacturer_ref,
        }
    }

    setEditMode() {
        this.editMode = true
    }

    cancelEditMode() {
        this.editMode = false
    }


    saveEditMode() {
        this.cancelEditMode()
        this.ean13 = this.datasEditInline.ean13
        this.upc = this.datasEditInline.upc
        this.variation_value_id = this.datasEditInline.variation_value_id
        this.external_ref = this.datasEditInline.external_ref
        this.mf_price_public = this.datasEditInline.mf_price_public
        this.ref_kwisatz = this.datasEditInline.ref_kwisatz
        this.price_speedway = this.datasEditInline.price_speedway
        this.date_dispo_pim = this.datasEditInline.date_dispo_pim
        this.manufacturer_ref = this.datasEditInline.manufacturer_ref
        return this.datasEditInline
    }

}
